module.exports = __webpack_public_path__ + "assets/belnovosti.72d0225d.svg";